import React, { useState } from "react";

export default function useMenuState() {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorElement);

  const handleOpen = <T extends HTMLElement>(event: React.MouseEvent<T>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleClose = () => setAnchorElement(null);

  return {
    anchorEl: anchorElement,
    handleClose,
    handleOpen,
    isOpen,
  };
}
